<template>
  <b-card title="Péage">
    <div class="custom-search d-flex justify-content-end mb-3">
      <b-form-group>
        <div class="d-flex align-items-center">
          <label class="mr-1">Recherche</label>
          <b-form-input
            v-model="searchTerm"
            placeholder="Recherche"
            type="text"
            class="d-inline-block mr-2"
          />
          <b-button variant="primary" @click="openAddModal">
            <span>Ajouter Péage</span>
          </b-button>
        </div>
      </b-form-group>
    </div>

    <vue-good-table
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :search-options="{ enabled: true, externalQuery: searchTerm }"
      :pagination-options="{ enabled: true, perPage: pageLength }"
    >
      <template v-slot:table-row="props">
        <template v-if="props.column.field === 'name'">
          <span>{{ props.row.name }}</span>
        </template>
        <template v-else-if="props.column.field === 'active'">
          <b-badge :variant="statusVariant(props.row.active)">
            {{ props.row.active ? "Actif" : "Désactivé" }}
          </b-badge>
        </template>
        <template v-else-if="props.column.field === 'action'">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <more-vertical-icon size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="openEditModal(props.row)">
              <edit-2-icon class="mr-50" />
              <span>Modifier</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="props.row.isUsed"
              @click="deactivateTollHandler(props.row.id,!props.row.active)"
            >
              <ToggleLeftIcon class="mr-50" />
              <span>
                {{ props.row.active ? "Désactiver" : "Activer" }}
              </span>
            </b-dropdown-item>
            <b-dropdown-item
              v-else
              @click="deleteTollHandler(props.row.id)"
            >
              <trash-icon class="mr-50" />
              <span>Supprimer</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </template>

      <template v-slot:pagination-bottom="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center">
            <span class="mr-1">Afficher</span>
            <b-form-select
              v-model="pageLength"
              :options="[3, 5, 10, 25, 50, 100, 200]"
              class="mx-1"
              @input="value => props.perPageChanged({ currentPerPage: value })"
            />
            <span>sur {{ props.total }} données</span>
          </div>
          <!-- <b-pagination
            v-model="currentPage"
            :total-rows="props.total"
            :per-page="pageLength"
            first-number
            last-number
            align="right"
          /> -->

           <b-pagination
          :value="1"
          :total-rows="props.total"
          :per-page="pageLength"
          first-number
           last-number
            align="right"
            prev-class="prev-item"
            next-class="next-item"
            class="mt-1 mb-0"
            @input="value => props.pageChanged({ currentPage: value })">
            <template #prev-text>
              <chevron-left-icon size="18" />
            </template>
            <template #next-text>
              <chevron-right-icon size="18" />
            </template>
          </b-pagination>
        </div>
      </template>
    </vue-good-table>

    <b-modal v-model="isModalActive" :title="modalTitle"   @hidden="resetModal"   @hide="resetModal" cancelTitle="Fermer" cancel-variant="outline-secondary"
      @ok="handleOk">
      <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-form-group ref="nameinput" :state="nameState" label="Nom du Péage"  label-for="name-input" invalid-feedback="Ce champ est requis.">

          <b-form-input
          id="name-input"
            v-model="currentPeage.name"
            required
            placeholder="Entrez le nom"
            :state="nameState"
          />
          <b-form-invalid-feedback />
        </b-form-group>

      </form>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BButton,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BPagination,
  BModal,
  BForm,
  BCard,
  BFormInvalidFeedback,

} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { MoreVerticalIcon, Edit2Icon, TrashIcon,ToggleLeftIcon,ChevronLeftIcon,
  ChevronRightIcon, } from "vue-feather-icons";
import {
  allPeages,
  saveToll,
  updateToll,
  deleteToll,
  updateDisabledToll,
} from "@/services/TollService";
import {extend} from "vee-validate";
const forbiddenPatterns = [
      /<\s*\/?\s*[a-zA-Z][a-zA-Z0-9_-]*\s*.*?>/i,
      /<\s*script/i,
      /<\s*style/i,
      /on\w+\s*=/i,
      /(javascript|data|vbscript):/i,
      /(\$\{[^}]*\}|\{\{[^}]*\}\}|#\{[^}]*\})/,
      /(%3C|%3E|&#\d+;|&#x[0-9a-fA-F]+;|\\u[0-9a-fA-F]{4}|\\x[0-9a-fA-F]{2})/i,
  /<!--|--\>/i
];

export default {
  components: {
    BCard,
    VueGoodTable,
    // BForm,
    BFormGroup,
    BButton,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BPagination,
    BModal,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    MoreVerticalIcon,
    Edit2Icon,
    TrashIcon,
    ToggleLeftIcon,
    ChevronLeftIcon,
  ChevronRightIcon,
    BFormInvalidFeedback,

  },
  data() {
    return {
      pageLength: 10,
      currentPage: 1,
      columns: [
        { label: "Péage", field: "name" },
        { label: "Statut", field: "active" },
        { label: "Action", field: "action" },
      ],
      rows: [],
      searchTerm: "",
      isModalActive: false,
      isEditMode: false,
      modalTitle: "",
      currentPeage: { name: "" },
      nameState: null,

    };
  },
  computed: {
    statusVariant() {
      return status => (status ? "light-primary" : "light-danger");
    },
    direction() {
      return false;
    },
  },
  methods: {
    checkFormValidity() {
      // Vérification des champs et mise à jour des états
      this.nameState = this.currentPeage.name.trim() === "" ? false : null;

      // Retourne `false` si un des champs est invalide
      return this.nameState === null;
    },
    validateName() {
      if (!this.currentPeage.name) return







      return !forbiddenPatterns.some(pattern => pattern.test(this.currentPeage.name));

    },

    async fetchPeages() {
      try {
        this.rows = await allPeages();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    openAddModal() {
      this.isEditMode = false;
      this.modalTitle = "Ajouter Péage";
      this.isModalActive = true;
    },
    openEditModal(peage) {
      this.isEditMode = true;
      this.modalTitle = "Modifier Péage";
      this.currentPeage = { ...peage };
      this.isModalActive = true;
    },
    resetModal() {
      this.currentPeage = { name: "" };
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    async handleSubmit() {
      // if (!this.currentPeage.name.trim()) {
      //   this.showToast("Le nom est requis.");
      //   return;
      // }
      if (!this.checkFormValidity()|| !this.validateName()) return;
      // this.currentPeage.name = this.replaceString();
      try {
        if (this.isEditMode) {
          const updatedPeage = await updateToll(this.currentPeage.id, this.currentPeage);
          const index = this.rows.findIndex(row => row.id ===updatedPeage.id);
          if (index !== -1) this.$set(this.rows, index, updatedPeage);
          this.showToast("Péage modifié avec succès.");
          this.resetModal();
        this.isModalActive = false;

        } else {
          const newPeage = await saveToll(this.currentPeage);
          this.rows.push(newPeage);
           this.resetModal();
          this.showToast("Péage ajouté avec succès.");
        }
      } catch (error) {
        console.error("Error saving data:", error);
      }
    },
    async deleteTollHandler(tollId) {
      try {
        await deleteToll(tollId);
        this.rows = this.rows.filter(row => row.id !== tollId);
        this.showToast("Péage supprimé avec succès.");
      } catch (error) {
        console.error("Error deleting data:", error);
      }
    },
    async deactivateTollHandler(tollId,active) {
      try {
        this.currentPeage.active=active;
        this.currentPeage= await updateDisabledToll(tollId,this.currentPeage);
        const row = this.rows.find(r => r.id === tollId);
        if (row) {
          row.isUsed = this.currentPeage.isUsed;
          row.active = this.currentPeage.active;
        }
        if(this.currentPeage.active){
          this.showToast("Péage activé avec succès.");

        }else{
          this.showToast("Péage désactivé avec succès.");

        }
      } catch (error) {
        console.error("Error deactivating data:", error);
      }
    },
    showToast(message) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: "CheckCircleIcon",
          variant: "success",
        },
      });
    },
  },
  created() {
    this.fetchPeages();
  },
};
</script>

<style scoped>
@import "~vue-good-table/dist/vue-good-table.css";
</style>
